import { http } from './index';
import { LucaLabelModel } from '@types';

// 新增标注模版
export const addLabelModel = (params: LucaLabelModel) => http.post('/teaching-workbench/api/v1/feedback/add/classify', params);
// 更新标注模版
export const updateLabelModel = (params: LucaLabelModel | any ) => http.post('/teaching-workbench/api/v1/feedback/update/classify', params);
// 获取标注模版
export const getLabelModelDetail = (params: any) => http.post('/teaching-workbench/api/v1/feedback/get/classify-detail', params);

// 新增标注任务
export const addLabelExtractTask = (params: any) => http.post('/teaching-workbench/api/v1/feedback/add/label-extract-task', params);

// 获取标注任务
export const getLabelExtractTask = (params: any) => http.get(`/teaching-workbench/api/v1/feedback/get/label-extract-task/${params.id}`);
// 更新标注任务
export const updateLabelExtractTask = (params: any) => http.post('/teaching-workbench/api/v1/feedback/update/label-extract-task', params);

// 新增标注任务分配
export const addLabelTaskAssign = (params: any) => http.post('/teaching-workbench/api/v1/feedback/add/label-task-assign', params);

// 更新标注任务分配
export const updateLabelTaskAssign = (params: any) => http.post('/teaching-workbench/api/v1/feedback/update/label-task-assign', params);

// 获取标注任务分配
export const getLabelTaskAssign = (params: any) => http.get(`/teaching-workbench/api/v1/feedback/get/label-task-assign/${params.id}`);

export const getExtractQuestionList = (params: any) => http.post('/teaching-workbench/api/v1/extract-question-record/page', params);

// 认领/指派
export const claimAssign = (params: any) => http.post('/teaching-workbench/api/v1/extract-question-record/claim-assign', params);
//转派标注任务
export const transferTask = (params: any) => http.post('/teaching-workbench/api/v1/extract-question-record/transfer', params);


export const getLucaTaskDetail = (params: any) => http.get('/teaching-workbench/api/v1/luca/ask/statistics/detail', params);

export const getExtractQuestionDetail = (params: any) => http.get('/teaching-workbench/api/v1/extract-question-record/detail', params);

export const addCorrect = (params: any) => http.post('/teaching-workbench/api/v1/extract-question-record/add-correct', params);

export const getExtractQuestionContent = (params: any) => http.get('/teaching-workbench/api/v1/extract-question-record/content', params);

export const notNeedCorrect = (params: any) => http.get('/teaching-workbench/api/v1/extract-question-record/not-need-correct', params);


export const getProjectSubject = (params?: any) => http.get('/teaching-workbench/api/v1/feedback/list/user-project-subject', params);

export const getOperateUser = (params: any) => http.post('/teaching-workbench/api/v1/extract-question-record/operate-user', params);